var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"12","height":"19","viewBox":"0 0 12 19","fill":"none"}},[_c('path',{attrs:{"d":"M2.00043 16.8286L9.49164 2.00049","stroke":"#8DA5C5","stroke-width":"4","stroke-linecap":"round"}})])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }